import { TracerRegistry } from "./registry";
import type { Tracer } from "./tracer";

/**
 * Configuration for tracing
 */
export interface TracingConfig {
  /**
   * Whether tracing is enabled
   */
  enabled: boolean;

  /**
   * Name of the tracer to use (must be registered first)
   */
  tracer?: string;

  /**
   * Global metadata to include with all traces
   */
  metadata?: Record<string, unknown>;
}

/**
 * Initialize tracing with the specified configuration
 * 
 * @param config Tracing configuration
 */
export function initTracing(config: TracingConfig): void {
  const registry = TracerRegistry.getInstance();
  
  if (config.enabled && config.tracer) {
    try {
      registry.setActiveTracer(config.tracer);
    } catch (error) {
      console.warn(`Failed to set tracer '${config.tracer}'. Using null tracer instead.`);
    }
  }
}

/**
 * Register a custom tracer with the system
 * 
 * @param name Name of the tracer
 * @param tracer The tracer implementation
 */
export function registerTracer(name: string, tracer: Tracer): void {
  const registry = TracerRegistry.getInstance();
  registry.register(name, tracer);
} 